<template>
  <header class="header" v-if="stateWindowWidth < 992">
    <div class="header__logo header__logo--choice">
      <router-link :to="$route.path.match(/gogatsu/) ?  config.path.root_gogatsu : config.path.root">
        <img src="/choice/img/common/choice-logo-horizontal.svg" alt="WEB de カスタマイズ">
      </router-link>
    </div>
    <div class="header__logo header__logo--hitotoe">
    
        <router-link target="_blank" rel="noopener" :to="$route.path.match(/gogatsu/) ? '/gogatsu_ningyou' : '/'">
            <img src="/choice/img/common/hitotoe-logo.svg" alt="ひととえ">
        </router-link>

    </div>
  </header>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-item-img': require('@/components/item-img.vue').default,
    'v-prev-dialog': require('@/components/prev-dialog.vue').default,
  },
  props: {
    index: Number,
    item: Object,
    filter: Array,
    imgHeight: Object,
  },
  computed: {
    ...mapState({
      stateWindowWidth: state => state.window.width,
    }),
  },
}
</script>



<style lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: map-get($z-index, header);
  background-color: #fff;
  width: 100%;
  height: 42px;
  padding-left: 16px;
  padding-right: 16px;
  &__logo {
    a {
      display: inline-block;
      height: 42px;
    }
    img {
      display: block;
    }
    &--choice {
      a {
        padding-top: 12px;
      }
      img {
        height: 18px;
      }
    }
    &--hitotoe {
      a {
        padding-top: 8px;
      }
      img {
        height: 22px;
      }
    }
  }
}
</style>
